import { useEffect, useState } from 'react';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { Module_Enum, useGetLastImportTaskQuery } from 'generated/graphql';

import { Warning } from './use-import-task';

interface LastTask {
  id: string;
  segmentCreated: number;
  segmentUpdated: number;
  segmentFailed: number;
  endDate?: string;
  warnings?: Warning;
}

export interface OngoingTask {
  createdAt: string;
}

export const useOngoingImportTaskData = (projectId: string) => {
  const [lastImportTask, setLastImportTask] = useState<LastTask | undefined>(
    undefined,
  );
  const [ongoingTask, setOngoingTask] = useState<OngoingTask | undefined>(
    undefined,
  );

  const gqlHeaders = useGraphqlApiHeaders(Module_Enum.QualityScan);
  const { data } = useGetLastImportTaskQuery({
    variables: {
      projectId,
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    pollInterval: 15000, // every 15s
    context: {
      headers: gqlHeaders,
    },
  });

  useEffect(() => {
    if (data) {
      setLastImportTask(
        data.lastTask.length > 0 ? data.lastTask[0] : undefined,
      );
    }

    if (data) {
      setOngoingTask(
        data.ongoingTask.length > 0 ? data.ongoingTask[0] : undefined,
      );
    }
  }, [data]);

  return {
    lastImportTask,
    ongoingTask,
    setOngoingTask,
  };
};
